import { TankEntity, TankFilter } from '../../models'

export const SET_TANKS = 'SET_TANKS'
export const SET_TANKS_LOADED = 'SET_TANKS_LOADED'
export const SET_TANK_FILTER = 'SET_TANK_FILTER'
export const SET_SELECTED_TANK = 'SET_SELECTED_TANK'

export interface TankState {
  tanks: TankEntity[]
  isTanksLoaded: boolean
  tankFilter: TankFilter
  selectedTank?: TankEntity
}

interface SetTankFilterAction {
  type: typeof SET_TANK_FILTER
  payload: TankFilter
}

interface SetSelectedTankAction {
  type: typeof SET_SELECTED_TANK
  payload?: TankEntity
}

interface SetTanksAction {
  type: typeof SET_TANKS
  payload: TankEntity[]
}

interface SetTanksLoadedAction {
  type: typeof SET_TANKS_LOADED
  payload: boolean
}

export type TankAction =
  | SetTankFilterAction
  | SetSelectedTankAction
  | SetTanksAction
  | SetTanksLoadedAction
